Vendd.Scripts.load(function () {
    var $form = $('.x-callmeback-form'), $submitButton, form, formData;

    if ($form.length < 1)
        return;

    $submitButton = $('.js-submit-button', $form);

    form = $form.get(0);

    formData = {
        firstName: $("input[name='firstName']", $form).val() ? $("input[name='firstName']", $form).val() : "",
        lastName: $("input[name='lastName']", $form).val() ? $("input[name='lastName']", $form).val() : "",
        email: $("input[name='email']", $form).val() ? $("input[name='email']", $form).val() : "",
        phone: $("input[name='phone']", $form).val() ? $("input[name='phone']", $form).val() : "",
        message: $("input[name='message']", $form).val() ? $("input[name='message']", $form).val() : ""
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        var data = envelope.message.data;

        if (data.success && data.code === "CallMeBack_OperationSuccesful") {
            $('.js-error', $form).hide();
            $('.js-content', $form).hide();

            $('.js-success', $form).show();
        } else {
            $('.js-error', $form).show();
        };
    };

    form.onFailure = function (envelope) {
        form.loading(false);

        $('.js-error', $form).show();
    };

    form.submit = function () {
        form.loading(true);

        Vendd.MessageBus.publishAsync(form, new Vendd.CallMeBack.Messages.Submit(
            formData.email,
            formData.firstName,
            formData.lastName,
            formData.phone,
            formData.message
        ));
    };

    form.reset = function () {
        $('.js-error', $form).hide();
        $('.js-success', $form).hide();
        $('.js-content', $form).show();

        $('input[name="firstName"]', $form).val("");
        $('input[name="lastName"]', $form).val("");
        $('input[name="email"]', $form).val("");
        $('input[name="phone"]', $form).val("");
        $('input[name="message"]', $form).val("");

        cmbf.reset();
    };

    $form.on('click', '.js-submit-button', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var val = cmbf.validate();

        if (val) form.submit();
    });

    $form.on('keyup', 'input[name], textarea[name]', function (e) {
        if (e.keyCode === 13) {

            if ($(this).prop("tagName").toLowerCase() === "textarea")
                return true;

            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        }

        var $this = $(this);
        var fieldName = $this.attr('name');

        formData[fieldName] = $this.val();

        cmbf.validate(fieldName);
    });

    //init validation options
    var validationOptions = {};

    //add required validations
    $.each($('input[data-required], textarea[data-required], select[data-required]', $form), function (e, el) {
        var inputName = $(el).attr('name');
        validationOptions[inputName] = { required: inputName + '-required' };
    });

    //add email validation
    if ($('input[name="email"]', $form).length > 0) {
        validationOptions.email = validationOptions.email || {};
        _.extend(validationOptions.email, { isEmail: 'email-invalid' });
    }

    //add phone validation
    if ($('input[name="phone"]', $form).length > 0) {
        validationOptions.phone = validationOptions.phone || {};
        if (venddProjectConfigs.phoneLocalizationEnabled) {
            _.extend(validationOptions.phone, { isValidPhoneLocalized: { validator: 'phone-invalid', config: { type: 'both' } } });
        } else {
            _.extend(validationOptions.phone, { isPhoneNumber: 'phone-invalid' });
        }
    }

    $form.validationEngine(validationOptions);
    var cmbf = $form.data('validationEngine');

    if (venddProjectConfigs.phoneLocalizationEnabled) {
        if ($('input[name="phone"]', $form).length > 0) {
            $('input[name="phone"]', $form).get(0).addEventListener("countrychange", function () {
                formData.phone = $(this).val();
                cmbf = $form.data('validationEngine');
                cmbf.validate('phone');
            });
        }
    }

    Vendd.MessageBus.subscribe(Vendd.CallMeBack.Messages.SubmitSuccess, form, form.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.CallMeBack.Messages.SubmitFailure, form, form.onFailure);

});
